export default {
  getLocal(state) {
    return state.local
  },
  getAvailableLanguages(state) {
    return state.availableLanguages
  }
}
